module.exports = __webpack_public_path__ + "static/media/help.032bf158.svg";